import Base from './condition-base'
import renderFields from './notification-click.pug'

export default class NotificationClick extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
